import { config } from '@fortawesome/fontawesome-svg-core';
// image
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
// theme
//import ThemeProvider from 'src/theme';
// locales
import { LocalizationProvider } from 'src/locales';
// hooks
//import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
// import ProgressBar from 'src/components/progress-bar';
// import { MotionLazy } from 'src/components/animate/motion-lazy';
// import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/msal';
// analytics
import { track, trackPendingSignIn } from 'src/utils/track';

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export const onClientEntry = () => {
  /* Prevents fontawesome auto css insertion */
  config.autoAddCss = false;
};

/**
 * Reports each page view. Fires on the first load as well as on every in-app navigation, which is
 * the only way the pack's own pages are seen at all - they are static files Gatsby serves without
 * calling a function, so nothing server-side knows they were opened.
 *
 * Anonymous visitors are discarded by the endpoint, not here: whether there is a session is only
 * knowable from /.auth/me, and asking per navigation would cost more than the view it is reporting.
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Only the previous page on this site is sent. document.referrer would be an external URL on a
  // first load, and the server keeps a path and discards the host - so an arrival from a search
  // engine would be filed under whatever its result page happened to be, which is worse than blank.
  trackPendingSignIn(location?.pathname);
  track('pageview', location?.pathname, prevLocation?.pathname);
};
export const wrapRootElement = ({ element }) => {
  //useScrollToTop();
  //const root = ReactDOM.createRoot(element);

  return (
    <AppRoot>
      <AuthProvider>
        <LocalizationProvider>{element}</LocalizationProvider>
      </AuthProvider>
    </AppRoot>
  );
};
const AppRoot = ({ children }) => {
  return (
    <HelmetProvider>
      <React.Suspense>{children}</React.Suspense>
    </HelmetProvider>
  );
};
